import React from 'react'
import { 
  Package, 
  ShoppingCart, 
  TrendingUp, 
  Truck, 
  Clock, 
  CheckCircle,
  AlertCircle,
  MoreHorizontal,
  Search,
  Bell,
  User,
  Menu,
  X,
  Calendar,
  Filter
} from 'lucide-react';

// const Statcard = ({ title, value }) => {
//    return (
//     <div className="bg-white p-4 rounded-md shadow h-40 w-96 ">
//       <p className="text-sm text-gray-500">{title}</p>
//       <p className="text-2xl font-bold text-gray-800">{value}</p>
//     </div>
//   );
// }

const StatCard = ({ title, value, icon: Icon, trend, trendValue, color = "blue" }) => {
  const colorClasses = {
    blue: "bg-blue-50 text-blue-600 border-blue-200",
    green: "bg-green-50 text-green-600 border-green-200",
    purple: "bg-purple-50 text-purple-600 border-purple-200",
    orange: "bg-orange-50 text-orange-600 border-orange-200"
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-lg ${colorClasses[color]}`}>
          <Icon className="h-6 w-6" />
        </div>
        {trend && (
          <div className={`flex items-center text-sm ${trend === 'up' ? 'text-green-600' : 'text-red-600'}`}>
            <TrendingUp className={`h-4 w-4 mr-1 ${trend === 'down' ? 'rotate-180' : ''}`} />
            {trendValue}
          </div>
        )}
      </div>
      <div>
        <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
        <p className="text-2xl font-bold text-gray-900">{value}</p>
      </div>
    </div>
  );
};

export default StatCard